import { sortBy } from 'lodash';

import type { IntlShape } from 'react-intl';
import type { ChangelogFormat, ChangelogSection } from './types';

export type ChangelogSectionGroup = {
  items: ChangelogFormat[];
  section: ChangelogSection;
};

export function getSectionTitle(section: ChangelogSection, formatMessage: IntlShape['formatMessage']): string {
  const titles: Record<ChangelogSection, string> = {
    advancedCpm: formatMessage({ defaultMessage: 'Advanced CPM Options', id: 'changelogModal.section.advancedCpm' }),
    audiences: formatMessage({ defaultMessage: 'Audiences', id: 'changelogModal.section.audiences' }),
    flights: formatMessage({ defaultMessage: 'Flights', id: 'changelogModal.section.flights' }),
    general: formatMessage({ defaultMessage: 'General', id: 'changelogModal.section.general' }),
    locations: formatMessage({ defaultMessage: 'Locations', id: 'changelogModal.section.locations' }),
    other: formatMessage({ defaultMessage: 'Other', id: 'changelogModal.section.other' }),
    pricingModel: formatMessage({ defaultMessage: 'Pricing Model', id: 'changelogModal.section.pricingModel' }),
    schedule: formatMessage({ defaultMessage: 'Schedule', id: 'changelogModal.section.schedule' }),
    screens: formatMessage({ defaultMessage: 'Screens', id: 'changelogModal.section.screens' }),
    venues: formatMessage({ defaultMessage: 'Venues', id: 'changelogModal.section.venues' })
  };
  return titles[section];
}

/** Sorts by order and groups by section; sections appear in the order of their first item */
export function groupChangelogSections(formats: ChangelogFormat[]): ChangelogSectionGroup[] {
  return sortBy(formats, 'order').reduce<ChangelogSectionGroup[]>((groups, format) => {
    const group = groups.find(({ section }) => section === format.section);
    if (group) {
      group.items.push(format);
    } else {
      groups.push({ items: [format], section: format.section });
    }
    return groups;
  }, []);
}
